const topics = [
  { label: '古装剧推荐', count: '2.3万' },
  { label: '悬疑烧脑', count: '1.8万' },
  { label: '韩剧热播', count: '1.6万' },
  { label: '国产高分', count: '3.1万' },
  { label: '甜宠爱情', count: '2.7万' },
  { label: '仙侠奇幻', count: '1.9万' },
  { label: '犯罪刑侦', count: '1.5万' },
  { label: '院线新片', count: '2.8万' },
  { label: '美剧精选', count: '1.2万' },
  { label: '喜剧搞笑', count: '1.4万' },
  { label: '动画动漫', count: '2.0万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">发现大家都在讨论的影视话题</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}